<template>
  <div>
    <v-subheader v-if="singleLine && !notitle" :class="[`px-0 body-2 ${labelColor}--text my-4`]">
      <div :style="{ fontSize: fontSize, fontWeight: weight }" v-html="label"></div> {{ required ? '*' : '' }}
    </v-subheader>
    <v-subheader v-if="topHint" :class="[`px-0 body-2 ${labelColor}--text my-4`]">
      <div :style="{ fontSize: fontSize, fontWeight: weight }" v-html="topHint"></div> {{ required ? '*' : '' }}
    </v-subheader>
    <template v-if="row">
      <v-row dense>
        <v-col v-for="(item, i) in items" :key="i" v-bind="itemGrid">
          <v-checkbox
            class="mt-0"
            v-model="form"
            :label="item.text"
            :value="+item.value"
            :disabled="disabled"
            :error-messages="errorMessages"
            :readonly="readonly"
            hide-details
          ></v-checkbox>
          <div v-if="isOpsiLain && (form || []).includes(+item.value)" class="mt-1 mb-2">
            <v-text-field
              v-model="formData[`input-lain-${id}-${item.value}`]"
              :type="othersOpsi.type || 'text'"
              label=""
              placeholder="Tuliskan jawaban"
              dense
              outlined
              hide-details
            />
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <div :class="[notitle ? '' : '']">
        <v-row v-for="(item, i) in items" :key="i" no-gutters style="flex-wrap: nowrap;" class="my-1 mb-2">
          <v-col cols="12" class="flex-grow-0 flex-shrink-0 my-auto">
            <v-checkbox
              class="mt-0"
              v-model="form"
              :label="item.text"
              :value="item.value"
              :disabled="disabled"
              :readonly="readonly"
              :multiple="multiple"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col
            v-if="isOpsiLain && (form || []).includes(+item.value)"
            cols="11"
            lg="2"
            class="flex-grow-1 flex-shrink-0"
          >
            <v-text-field
              v-model="formData[`input-lain-${id}-${item.value}`]"
              :type="othersOpsi.type || 'text'"
              label=""
              placeholder="Tuliskan jawaban"
              dense
              outlined
              hide-details
            />
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FormCheckbox',
  props: [
    'label',
    'labelColor',
    'required',
    'items',
    'value',
    'valueLain',
    'disabled',
    'formData',
    'row',
    'margin',
    'fontSize',
    'weight',
    'errorMessages',
    'itemGrid',
    'multiple',
    'topHint',
    'useLabel',
    'singleLine',
    'readonly',
    'notitle',
    'hideDetails',
    'isOpsiLain',
    'name',
    'id',
    'othersOpsi',
  ],
  data() {
    return {
      form: this.value || [],
      formLain: this.valueLain || '',
    };
  },
  computed: {
    keyLain() {
      const keys = (this.items || []).filter((item) => item.is_lain).map((item) => item.value);
      return keys[0];
    },
  },
  methods: {
    mutate(value) {
      this.$emit('input', value);
    },

    setForm(value) {
      this.$set(this, 'form', value);
    },

    setFormLain(value) {
      this.$set(this, 'formLain', value);
    },
  },
  watch: {
    form: 'mutate',
    value: 'setForm',
    valueLain: 'setFormLain',
  },
};
</script>

<style scoped></style>
